// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('nav');
    if (menuToggle && nav) {
        menuToggle.addEventListener('click', function() {
            menuToggle.classList.toggle('active');
            nav.classList.toggle('active');
        });
    }

    // Close menu when clicking on a link
    const navLinks = document.querySelectorAll('nav a');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            menuToggle.classList.remove('active');
            nav.classList.remove('active');
        });
    });

    // Handle Waitlist Form Submission
    const waitlistForm = document.getElementById('waitlistForm');
    const formMessage = document.getElementById('formMessage');
    const submitButton = document.getElementById('submitButton');

    if (waitlistForm) {
        waitlistForm.addEventListener('submit', function(e) {
            e.preventDefault();

            // Get form data
            const name = document.getElementById('name').value;
            const email = document.getElementById('email').value;
            const turnstileResponse = document.querySelector('[name="cf-turnstile-response"]')?.value;

            // Validate form
            if (!name || !email) {
                showFormMessage('Please fill in all required fields.', 'error');
                return;
            }

            if (!turnstileResponse) {
                showFormMessage('Please complete the security check.', 'error');
                return;
            }

            // Show loading state
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';

            fetch('/save-waitlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name,
                    email,
                    'cf-turnstile-response': turnstileResponse
                })
            })
                .then(response => {
                    if (response.ok) {
                        showFormMessage('Thank you for joining our waitlist! We\'ll be in touch soon.', 'success');
                        waitlistForm.reset();
                        submitButton.disabled = true;
                        submitButton.textContent = 'Join Waitlist';
                        if (window.turnstile) window.turnstile.reset();
                    } else if (response.status === 403) {
                        showFormMessage('Captcha verification failed. Please try again.', 'error');
                        submitButton.disabled = false;
                        submitButton.textContent = 'Join Waitlist';
                        if (window.turnstile) window.turnstile.reset();
                    } else if (response.status === 409) {
                        showFormMessage('You’ve already joined the waitlist.', 'error');
                    } else {
                        showFormMessage('Something went wrong. Please try again later.', 'error');
                        submitButton.disabled = false;
                        submitButton.textContent = 'Join Waitlist';
                    }
                })
                .catch(() => {
                    showFormMessage('Network error. Please try again.', 'error');
                    submitButton.disabled = false;
                    submitButton.textContent = 'Join Waitlist';
                });
        });
    }

    // Helper function to display form messages
    function showFormMessage(message, type) {
        if (formMessage) {
            formMessage.textContent = message;
            formMessage.className = 'form-message';

            if (type) {
                formMessage.classList.add(type);
            }

            // Auto-hide error messages after 5 seconds
            if (type === 'error') {
                setTimeout(() => {
                    formMessage.textContent = '';
                    formMessage.className = 'form-message';
                }, 5000);
            }
        }
    }
});

// Cloudflare Turnstile callback
function turnstileCallback(token) {
    const submitButton = document.getElementById('submitButton');
    if (submitButton) {
        submitButton.disabled = false;
    }
}

// Handle smooth scrolling for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();

        const targetId = this.getAttribute('href');

        if (targetId === '#') return;

        const targetElement = document.querySelector(targetId);

        if (targetElement) {
            // Add offset for fixed header
            const headerHeight = document.querySelector('header').offsetHeight;
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

            window.scrollTo({
                top: targetPosition - headerHeight,
                behavior: 'smooth'
            });
        }
    });
});

// Intersection Observer for fade-in animations
const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
};

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-visible');
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

// Add fade-in class to sections and observe them
document.querySelectorAll('section').forEach(section => {
    if (!section.classList.contains('hero')) {
        section.classList.add('fade-in');
        observer.observe(section);
    }
});

// Add styles for fade-in animations
const style = document.createElement('style');
style.textContent = `
    .fade-in {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.6s ease, transform 0.6s ease;
    }
    
    .fade-in-visible {
        opacity: 1;
        transform: translateY(0);
    }
`;
document.head.appendChild(style);
